import { Link } from "react-router-dom";
import useSeo from "../lib/useSeo";

export default function NotFound() {
  useSeo("Lost", "This coordinate does not exist.");
  return (
    <section className="px-5 sm:px-8 lg:px-12 pt-40 pb-32 min-h-[70vh]" data-testid="not-found-page">
      <p className="eyebrow mb-6">x: null / y: null</p>
      <h1 className="f-display font-black uppercase text-7xl sm:text-9xl leading-[0.85]">Off the grid.</h1>
      <Link to="/" className="inline-block mt-10 f-mono text-xs uppercase tracking-[0.2em] link-u" data-testid="not-found-home-link">Return to origin</Link>
    </section>
  );
}
